import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

const reducer = (state = INITIAL_STATE, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case '@paymentBondsOrders/CANCEL_ORDER_REQUEST': {
        draft.loading = true;

        break;
      }

      case '@paymentBondsOrders/CANCEL_ORDER_SUCCESS': {
        draft.loading = false;

        break;
      }

      case '@paymentBondsOrders/CREATE_ORDER_REQUEST': {
        draft.loading = true;

        break;
      }

      case '@paymentBondsOrders/CREATE_ORDER_SUCCESS': {
        draft.loading = false;

        break;
      }

      case '@paymentBondsOrders/FAILURE': {
        draft.loading = false;

        break;
      }

      default:
    }
  });

export default reducer;
